<template>
    <div>
        <!-- Imprimir Anexos -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Imprimir Anexos</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">

                        <div class="alert alert-danger" v-if="guias && !guias.length">
                            Nenhuma guia selecionada para impressão de anexos.
                        </div>

                        <template v-else>

                            <div class="alert alert-info" v-if="guias && guias.length">
                                {{ guias.length }} guia(s) selecionada(s) para impressão de anexos.
                            </div>

                            <div class="d-flex flex-column mb-2">
                                <az-input 
                                    sizing="sm"
                                    label="Gerar"
                                    type="button-group"
                                    :optionsList="[
                                        { id: 'U', search: 'PDF Único' }, 
                                        { id: 'Z', search: 'ZIP com os Anexos' }, 
                                    ]"
                                    optionsData="id"
                                    v-model="tipo_resultado">
                                </az-input>
                            </div>

                            <az-input
                                label="Tipo"
                                type="select"
                                optionsMode="aql"
                                optionsData="id_tipo_arquivo"
                                optionsDisplay="st_descricao"
                                :optionsName="'tipos_arquivo.index.' + model"
                                service="tipo_arquivos.index"
                                :optionsParm="{ fl_ativo: 1, model: model }"
                                placeholder="Selecionar o tipo de arquivo..."
                                required
                                :validate="validate"
                                v-model="id_tipo_arquivo">
                            </az-input>

                            <az-loading class="mt-3" v-if="buscando" />

                            <div v-else-if="retorno" class="mt-3">
                                <div class="alert alert-info d-flex justify-content-between">
                                    <div>
                                        <span v-if="retorno.qtde">{{ retorno.qtde }} documento(s) encontrado(s).</span>
                                        <span v-else>Nenhum documento encontrado.</span>
                                    </div>
                                    <div v-if="retorno.url">
                                        <a :href="retorno.url" class="card-link" target="_blank">Abrir/Imprimir</a>
                                    </div>
                                </div>
                            </div>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="imprimir()" :disabled="!( guias && guias.length )">Buscar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzLoading from '../../util/AzLoading.vue';

export default {
    data() {
        return { 
            id_tipo_arquivo: "", 
            guias: [], 
            model: 'marcacao', 
            validate: false, 
            retorno: null, 
            buscando: false, 
            modal_name: 'guiaImprimirAnexosModal', 
            tipo_resultado: 'U', 
        };
    },

    components: {
        AzInput,
        AzSubmit,
        AzLoading,
    },

    methods: { 
        abrir(guias) { 
            this.guias = _.cloneDeep(guias);
            this.retorno = null; 
            $('#' + this.modal_name).modal('show');
        },

        imprimir() {
            this.retorno = null; 
            this.buscando = true;

            this.$util.atualizar(this, { 
                service: 'guias', 
                func: 'imprimir_anexos',
                redir_api: true, 
                dados: { 
                    ids: this.guias.map(g => g.id_guia),
                    id_tipo_arquivo: this.id_tipo_arquivo,
                    tipo_resultado: this.tipo_resultado, 
                },
                callback: res => { 
                    this.retorno = res; 
                },
                final: () => { 
                    this.buscando = false;
                }
            });
            
        }

    },

    mounted() { 
        this.modal_name = 'guiaImprimirAnexosModal' + this.$util.uuidv4();
    }

}
</script>
